$(document).ready(function () {
    $(".in-index .products-block, .type-detail .products-related").each(function (index) {
        $(this).addClass("swiper-wrapper").wrap("<div class='whole-wrap'><div class='swiper myproducts-swiper myproducts-swiper-" + index + "'></div></div>");
        $("<div class='myswiper-navi myswiper-navi-" + index + "'><div class='fake-product'></div><div class='swiper-button-prev myswiper-prev'></div><div class='swiper-button-next myswiper-next'></div></div><div class='swiper-pagination swiper-pagination-" + index + "'></div>").appendTo($(this).parent(".myproducts-swiper").parent(".whole-wrap"));
        $($(this).find(".product")).addClass("swiper-slide");
        // freeMode na kraji wheel pouští dál → gesto zpět v prohlížeči; vodorovný swipe nad sliderem zastavíme
        this.closest('.myproducts-swiper').addEventListener('wheel', function (e) {
          if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) e.preventDefault();
        }, { passive: false });
        const productSwiper = new Swiper('.myproducts-swiper-' + index, {
          pagination: {
            el: '.swiper-pagination-' + index,
            clickable: true,
          },
          navigation: {
            nextEl: ".myswiper-navi-" + index + " .myswiper-next",
            prevEl: ".myswiper-navi-" + index + " .myswiper-prev",
          },
          slidesPerView: 'auto',
          spaceBetween: 20,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
            releaseOnEdges: false,
            sensitivity: 1,
            thresholdDelta: 10,
          },
          breakpoints: {
            0: {
                slidesPerView: 'auto',
                spaceBetween: 10,
                slidesOffsetBefore: 10,
                slidesOffsetAfter: 10,
            },
            768: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                spaceBetween: 10,
            },
            1440: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                spaceBetween: 20,
            }
        },
        });
    });
});